import React, { Component } from 'react';
import { exportsAvailableShape } from '../../../utils/propTypes';
import './ExportsAvailableListItem.scss';
import _ from 'lodash';
import { createReportName } from '../exportsUtil';
import Actions from '../Actions/Actions';

export default class ExportsAvailableListItem extends Component {
    static propTypes = {
        item: exportsAvailableShape.isRequired
    };

    render() {
        const item = _.get(this.props, 'item');

        return (
            <div className="exports-list-item-right">
                <div className="exports-list-items">
                    <div>
                        {createReportName(item)}
                    </div>
                    <div className="exports-list-item-right">
                        <Actions record={item} />
                    </div>
                </div>
            </div>
        );
    }
}
